(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 81382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(18730);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68856);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);






var variantClasses = {
    normal: "bg-white border border-gray-300 focus:shadow focus:outline-none focus:border-heading placeholder-placeholder",
    solid: "bg-gray-100 border border-gray-100 focus:bg-white focus:border-primary",
    outline: "border border-gray-300 focus:border-primary"
};
var TextArea = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function(props, ref) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var className = props.className, labelKey = props.labelKey, name = props.name, placeholderKey = props.placeholderKey, errorKey = props.errorKey, _variant = props.variant, variant = _variant === void 0 ? "normal" : _variant, _shadow = props.shadow, shadow = _shadow === void 0 ? false : _shadow, inputClassName = props.inputClassName, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "className",
        "labelKey",
        "name",
        "placeholderKey",
        "errorKey",
        "variant",
        "shadow",
        "inputClassName"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            labelKey && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: name,
                className: "mb-3 block text-sm font-semibold leading-none text-gray-600",
                children: t(labelKey)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                id: name,
                name: name,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex w-full appearance-none items-center px-4 py-3 text-sm text-heading transition duration-300 ease-in-out focus:outline-none focus:ring-0", shadow && "focus:shadow", variantClasses[variant], inputClassName),
                autoComplete: "off",
                spellCheck: "false",
                rows: 4,
                ref: ref,
                // @ts-ignore
                placeholder: t(placeholderKey)
            }, rest)),
            errorKey && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "my-2 text-xs text-red-500",
                children: t(errorKey)
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (TextArea);


/***/ }),

/***/ 45431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useStoreEmails; }
/* harmony export */ });
/* harmony import */ var _hooks_store_useStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8480);

function useStoreEmails(type) {
    var ref;
    var store = (0,_hooks_store_useStore__WEBPACK_IMPORTED_MODULE_0__/* .useStore */ .o)();
    return (ref = store.emails) === null || ref === void 0 ? void 0 : ref[type];
}


/***/ }),

/***/ 18730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ContactUsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/ui/divider.tsx
var divider = __webpack_require__(98121);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./src/components/ui/button.tsx
var ui_button = __webpack_require__(14685);
// EXTERNAL MODULE: ./src/components/ui/input.tsx
var input = __webpack_require__(50381);
// EXTERNAL MODULE: ./src/components/ui/text-area.tsx
var text_area = __webpack_require__(57818);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(68856);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__(83868);
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);
// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__(28355);
;// CONCATENATED MODULE: ./src/components/common/form/contact-form.gql.ts
var ContactFormDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ContactForm"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ContactInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "contactFormSubmit"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "status"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};

;// CONCATENATED MODULE: ./src/components/common/form/contact-form.tsx













var ContactForm = function() {
    var onSubmit = function onSubmit(values) {
        var _telephone;
        contactFormMutation({
            variables: {
                input: {
                    fullname: values.name,
                    email: values.email,
                    telephone: (_telephone = values.telephone) !== null && _telephone !== void 0 ? _telephone : "",
                    message: values.message
                }
            }
        });
    };
    var ref, ref1, ref2, ref3;
    var ref4 = (0,index_esm/* useForm */.cI)({
        mode: "onBlur"
    }), register = ref4.register, handleSubmit = ref4.handleSubmit, errors = ref4.formState.errors;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ContactFormDocument), 2), contactFormMutation = ref5[0], contactFormResult = ref5[1];
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    if (contactFormResult.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: t("contact-page-message-sent")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        className: "mx-auto flex w-full flex-col justify-center ",
        noValidate: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-5 md:flex-row md:space-y-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            labelKey: "forms:label-name-required",
                            placeholderKey: "forms:placeholder-name"
                        }, register("name", {
                            required: "forms:name-required",
                            pattern: {
                                value: /[a-zA-Z]+/,
                                message: "forms:name-error"
                            }
                        })), {
                            className: "w-full md:w-1/2 ",
                            errorKey: (ref = errors.name) === null || ref === void 0 ? void 0 : ref.message,
                            variant: "solid"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            labelKey: "forms:label-email-required",
                            type: "email",
                            placeholderKey: "forms:placeholder-email"
                        }, register("email", {
                            required: "forms:email-required",
                            validate: function(value) {
                                if (value && !isEmail_default()(value)) {
                                    return "forms:email-error";
                                }
                            }
                        })), {
                            className: "mt-2 w-full md:mt-0 md:w-1/2 md:ms-2.5 lg:ms-5",
                            errorKey: (ref1 = errors.email) === null || ref1 === void 0 ? void 0 : ref1.message,
                            variant: "solid"
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    labelKey: "forms:label-phone"
                }, register("telephone", {
                    validate: function(value) {
                        if (value && !(0,isMobilePhone/* default */.ZP)(value)) {
                            return "forms:phone-error";
                        }
                    }
                })), {
                    errorKey: (ref2 = errors.telephone) === null || ref2 === void 0 ? void 0 : ref2.message,
                    className: "relative",
                    variant: "solid"
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_area/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    labelKey: "forms:label-message-required"
                }, register("message", {
                    required: "forms:message-required"
                })), {
                    className: "relative mb-4",
                    placeholderKey: "forms:placeholder-message",
                    errorKey: (ref3 = errors.message) === null || ref3 === void 0 ? void 0 : ref3.message
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                        type: "submit",
                        className: "mt-1 w-full text-sm sm:w-auto lg:text-base",
                        loading: contactFormResult.loading,
                        children: t("button-send-message")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var contact_form = (ContactForm);

// EXTERNAL MODULE: ./src/components/ui/container.tsx
var container = __webpack_require__(89146);
// EXTERNAL MODULE: ./src/hooks/store/useStoreEmails.tsx
var useStoreEmails = __webpack_require__(45431);
// EXTERNAL MODULE: ./src/hooks/store/useStore.tsx
var useStore = __webpack_require__(8480);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
;// CONCATENATED MODULE: ./src/containers/contact-info.tsx





var ContactInfoBlock = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var store = (0,useStore/* useStore */.o)();
    var customerSupportEmail = (0,useStoreEmails/* useStoreEmails */.M)("customer_support_email").sender_email;
    var storeName = store === null || store === void 0 ? void 0 : (ref = store.store_information_config) === null || ref === void 0 ? void 0 : ref.store_name;
    var storeStreetAddressOne = store === null || store === void 0 ? void 0 : (ref1 = store.store_information_config) === null || ref1 === void 0 ? void 0 : ref1.store_street_address_one;
    var storeStreetAddressTwo = store === null || store === void 0 ? void 0 : (ref2 = store.store_information_config) === null || ref2 === void 0 ? void 0 : ref2.store_street_address_two;
    var storeCity = store === null || store === void 0 ? void 0 : (ref3 = store.store_information_config) === null || ref3 === void 0 ? void 0 : ref3.store_city;
    var storeAddressZipCode = store === null || store === void 0 ? void 0 : (ref4 = store.store_information_config) === null || ref4 === void 0 ? void 0 : ref4.store_zip_code;
    var storePhoneNumber = store === null || store === void 0 ? void 0 : (ref5 = store.store_information_config) === null || ref5 === void 0 ? void 0 : ref5.store_phone_number;
    var description = storeName + "<br/>" + storeStreetAddressOne + "<br/>" + (storeStreetAddressTwo ? storeStreetAddressTwo + "<br/>" : "") + storeAddressZipCode + " " + storeCity;
    var data = [
        {
            id: 1,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoLocationSharp */.UXH, {}),
            name: "text-address",
            description: description
        },
        {
            id: 2,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoMail */.GYo, {}),
            name: "text-email",
            description: customerSupportEmail
        },
        {
            id: 3,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCallSharp */.uYX, {}),
            name: "text-phone",
            description: storePhoneNumber
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-6 border-gray-300 lg:border lg:p-7",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "-mt-1 pb-7 text-2xl font-bold text-heading md:pb-10 md:text-lg lg:pb-6",
                children: t("text-contact")
            }),
            data === null || data === void 0 ? void 0 : data.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex pb-7 last:pb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-10 w-10 flex-shrink-0 items-center justify-center border border-gray-300 p-1.5",
                            children: item.icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col ps-3 2xl:ps-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "text-sm font-bold text-heading",
                                    children: t("".concat(item.name))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-0 text-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: item.description
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }, "contact--key".concat(item.id));
            })
        ]
    });
};
/* harmony default export */ var contact_info = (ContactInfoBlock);

;// CONCATENATED MODULE: ./src/pages/contact.tsx






var __N_SSG = true;
function ContactUsPage() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                className: "mb-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-14 mx-auto flex w-full flex-col px-0 pb-2 md:flex-row lg:my-16 xl:my-20 xl:max-w-screen-xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full flex-col md:w-full lg:w-2/5 2xl:w-2/6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_info, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex h-full flex-col md:w-full md:ms-7 lg:w-3/5 lg:ps-7 2xl:w-4/6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-7 flex pb-7 md:-mt-1.5 md:pb-9",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-2xl font-bold text-heading 2xl:text-3xl",
                                        children: t("text-get-in-touch")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_form, {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [553,819,928,888,179], function() { return __webpack_exec__(81382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);